<div class="card-body" *ngIf="processAppraiseeApproval$ | async as processAppraiseeApproval">
  {{ getComponentData(processAppraiseeApproval) }}
  <div class="row">
    <div class="row col-12">
      <div class="col-12 m-b-10 head-appraisee">
        <span class="caption">
          {{ 'lang.user.appraisee'  | translate }}:
        </span>
        <span class="name-appraisee">
          {{ processAppraiseeApproval.appraisee.displayName }}
        </span>
      </div>
      <div class="col-6">
        <div>
          <span class="caption">
              {{ 'lang.common.businessUnit'  | translate }}:
          </span>
          <span>
            {{ processAppraiseeApproval.appraisee.businessUnitDisplayName }}
          </span>
        </div>
        <div>
          <span class="caption">
              {{ 'lang.approval.approveTo'  | translate }}:
          </span>
          <span>
            {{ formatDate(processAppraiseeApproval.endDate) }}
          </span>
        </div>
      </div>
      <div class="col-6">
        <div>
          <span class="caption">
              {{ 'lang.common.process'  | translate }}:
          </span>
          <span>
            {{ processAppraiseeApproval.processName }}
          </span>
        </div>
        <div>
          <span class="caption">
              {{ 'lang.common.processTypes'  | translate }}:
          </span>
          <span *ngFor="let item of getProcessTypes(processAppraiseeApproval.processKnownTypes) as types; let i = index">
            {{ item }}<span *ngIf="i < types.length-1">, </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>